import React from 'react';
import { motion } from 'framer-motion'; 
import ShareBlogButton from '../../../components/ShareBlogButton/ShareBlogButton';
import './to-do-list-app.css';
import toDoListImage from '../../../assets/images/To-Do-List-App Image.png';

const ToDoListApp = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        To-Do <span>List App</span>
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
            Published On: 10th December 2024<br />
        🕒 Last Updated On: 10th December 2024
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={toDoListImage} alt="To-Do List App" className="project-image" />
          <h2 className="project-subtitle">To-Do List App</h2>
          <span className="project-category">App</span>
          <p className="project-author">Author: Praveen Kumar B</p>
          <p className="project-author">🕒3 Mins Read</p>
          <div className="blog-action-buttons">
            <a href="https://to-do-list-app-onlinenew.netlify.app/" className="visit-project-button">→ Visit the Project</a>
            <ShareBlogButton
              blog={{
                id: "to-do-list-app",
                title: "To-Do List App",
                path: "/blogs/blogdetail/to-do-list-app",
                category: "App"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">A Productivity Companion 📌</h3>
          <p className="overview-text">
            In a world buzzing with tasks, reminders, and responsibilities, staying organized is no longer optional—it's essential. The To-Do List App was born from that very realization. Built for simplicity and speed, this app is your digital notepad for everything that matters.
          </p>

          <h3 className="section-title">Why I Built It 🛠️</h3>
          <p className="overview-description">
            I’ve always believed productivity starts with clarity. Like many others, I found myself juggling between paper notes, reminder apps, and sticky notes. None of them truly fit. So, I decided to build my own solution—one that’s lightweight, intuitive, and completely accessible across devices.
          </p>

          <h3 className="section-title">A Peek Into the Experience 👀</h3>
          <p>
            The UI is intentionally clean, with a focus on function over flash. Whether you’re jotting down grocery items or outlining goals for the week, each task can be added with just a few taps. Editing and marking completed tasks is equally effortless. 
          </p>

          <h3 className="section-title">What Makes It Different? ✨</h3>
          <p>
            Unlike bloated apps filled with ads and unnecessary features, this To-Do List App does one thing—and does it well. Plus, it works offline. This means you can stay productive even without an internet connection—whether you’re in a flight or remote area.
          </p>

          <h3 className="section-title">Behind the Scenes 🔍</h3>
          <p>
            Built using the fundamentals—HTML, CSS, and JavaScript—the app stores tasks locally in your browser, ensuring fast load times and persistent data. It’s designed to be mobile-first but shines just as well on desktop. Future iterations may include cloud syncing via Firebase.
          </p>

          <h3 className="section-title">Use Cases In Real Life 🌍</h3>
          <p>
            From daily routines and academic deadlines to work sprints and shopping lists, the use cases are as varied as its users. Personally, I’ve used it to track code bugs, organize personal learning goals, and even plan travel essentials.
          </p>

          <h3 className="section-title">Looking Ahead 🔮</h3>
          <p>
            While the current version focuses on core features, I'm excited to expand its capabilities. Upcoming updates may include task prioritization, due dates with reminders, and cross-device syncing. The goal? To make this your go-to productivity tool, no matter where or how you work.
          </p>

          <h3 className="section-title">Final Thoughts 📝</h3>
          <p>
            The journey of building this app was both practical and personal. It's more than just a project—it's a reflection of my drive to solve real problems with simple, clean code. Whether you're a developer looking for inspiration or a user seeking structure in daily life, I hope this app brings value to your routine.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ToDoListApp;
